import React from 'react';
import { Progress } from 'antd';

const CustomProgress = props => {
  return <Progress {...props} />;
};

export default CustomProgress;
